// src/calls/utils/audioRoute.js
export function canSetSink() {
    return typeof HTMLMediaElement !== 'undefined'
        && typeof HTMLMediaElement.prototype.setSinkId === 'function';
}

export function canPickOutput() {
    return !!(navigator.mediaDevices && navigator.mediaDevices.selectAudioOutput);
}

export async function pickOutputDeviceId() {
    // Откроет системный диалог выбора устройства (где поддерживается)
    // Вернёт deviceId выбранного выхода
    const dev = await navigator.mediaDevices.selectAudioOutput();
    return dev && dev.deviceId ? dev.deviceId : '';
}

export async function listAudioOutputs() {
    if (!navigator.mediaDevices?.enumerateDevices) return [];
    const all = await navigator.mediaDevices.enumerateDevices();
    return all.filter(d => d.kind === 'audiooutput');
}

export async function routeToDevice(mediaEl, deviceId = '') {
    if (!canSetSink()) return false;
    try {
        await mediaEl.setSinkId(deviceId); // '' = системный по умолчанию
        return true;
    } catch (e) {
        console.warn('[audioRoute] setSinkId failed', e);
        return false;
    }
}

// ——— iOS/фолбэк: нет setSinkId — «переключаем» тип элемента ———
// Идея: audio => чаще «телефон», video (даже без видео-трека) => чаще «спикер»
export function routeFallbackIOS({ remoteAudioEl, remoteVideoEl, stream, to = 'earpiece' /* | 'speaker' */ }) {
    try {
        if (!remoteAudioEl || !stream) return false;

        if (to === 'earpiece') {
            remoteAudioEl.srcObject = stream;
            remoteAudioEl.play?.();
            if (remoteVideoEl) remoteVideoEl.srcObject = null;
            return true;
        } else {
            if (!remoteVideoEl) return false;
            remoteVideoEl.srcObject = stream;
            remoteVideoEl.play?.();
            return true;
        }
    } catch (e) {
        console.warn('[audioRoute] iOS fallback failed', e);
        return false;
    }
}

export function isIOS() {
    if (typeof navigator === 'undefined') return false;
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

export function isMobile() {
    if (typeof navigator === 'undefined') return false;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
